import { type FC } from 'react';
import { Button } from '@direct-frontend/components';

type ButtonAddStubProps = {
    children: string;
};

export const ButtonAddStub: FC<ButtonAddStubProps> = ({ children }) => (
    <Button color="contour" size="m" isDisabled>
        {children}
    </Button>
);
